const t = "styles-module__inputDescription___bAc0b", s = {
  inputDescription: t
};
export {
  s as default,
  t as inputDescription
};
